import { Mark, type Extensions } from '@tiptap/core';
import Link from '@tiptap/extension-link';
import StarterKit from '@tiptap/starter-kit';
import { isAllowedHref } from '@oscom/shared';

/**
 * Template text that still has to be replaced (design 2026-10-31). Not
 * inclusive: typing at its edge produces normal text; "Platzhalter auflösen"
 * removes the mark.
 */
export const PlaceholderMark = Mark.create({
  name: 'placeholder',
  inclusive: false,
  parseHTML() {
    return [{ tag: 'span[data-placeholder]' }];
  },
  renderHTML() {
    return ['span', { 'data-placeholder': '', class: 'rt-placeholder' }, 0];
  },
});

/**
 * Exactly the nodes and marks `checkRichText` allows - nothing else exists in
 * the schema, so pasting from Word cannot produce anything else either.
 */
export function richTextExtensions(): Extensions {
  return [
    StarterKit.configure({
      blockquote: false,
      code: false,
      codeBlock: false,
      heading: false,
      horizontalRule: false,
      strike: false,
      underline: false,
      // Configured separately below with the allowed schemes.
      link: false,
    }),
    Link.configure({
      openOnClick: false,
      autolink: true,
      linkOnPaste: true,
      defaultProtocol: 'https',
      isAllowedUri: (url) => isAllowedHref(url),
      HTMLAttributes: { rel: 'noopener noreferrer', target: null },
    }),
    PlaceholderMark,
  ];
}
